export default {
  buttons: {
    skip: 'Spring over',
    back: 'Tilbage',
  },
  toasts: {
    failed_to_load_data: 'Kunne ikke indlæse data',
    payment: {
      pending: 'Din betaling behandles i øjeblikket...',
      success: '👍 Din betaling blev gennemført. Tak!',
      error:
        '⁉️Der opstod et problem med din betaling, eller behandlingen tager længere tid end forventet. Prøv at opdatere siden i 1 minut, ellers kontakt teknisk support.',
    },
  },
};
